import { cva } from 'class-variance-authority'

export const itemStyles = cva(
  `
    space-y-2
  `
)

export const descriptionStyles = cva(
  `
    mb-2
    text-neutral-600
  `,
  {
    variants: {
      error: {
        true: `
          text-danger-100
        `,
      },
      disabled: {
        true: `
          text-neutral-400
          cursor-not-allowed
          opacity-50
        `,
      },
    },
    defaultVariants: {
      error: false,
      disabled: false,
    },
  }
)

export const bannerStyles = cva(
  `
    text-[0.8rem]
    font-medium
    w-full
  `
)
